import {useState} from 'react'
import StepNavigation from '../layout/StepNavigation'
import {useLocation} from 'react-router-dom'
import '../layout/Sidebar.css'
import {FaRegCommentDots} from 'react-icons/fa'
import { VscPreview} from 'react-icons/vsc'
import {GoIssueClosed} from 'react-icons/go'
import {IoMdContact} from 'react-icons/io'
import {MdReport} from 'react-icons/md'

const AdtrProgressBar = (props) => {
    const {openSection} = props
    const [selectedWidget, setSelectedWidget] = useState('issuance');
    const {pathname} = useLocation();

    const progressBarData = [
        {
            title: "Issuance",
            section: "issuance",
            icon: <img src="/assets/images/issuance.jpg" style={{width:'2rem', height: '2rem'}} alt="" />
        },
        {
            title: "Issuance Authorization",
            section: "issuanceAuthorization",
            icon: <img src="/assets/images/issuance.authorization.jpg" style={{width:'2rem', height: '2rem'}} alt="" />
        },
        {
            title: "Principal Outstanding",
            section: "principalOutstanding",
            icon: <MdReport style={{width:'2rem', height: '2rem'}}/>
        },
        {
            title: "Use of Proceeds",
            section: "useOfProceeds",
            icon: <GoIssueClosed  style={{width:'2rem', height: '2rem'}}/>
        },
        {
            title: "Filing Contact",
            section: "filingContact",
            icon: <IoMdContact style={{width:'2rem', height: '2rem'}}/>
        },
        {
            title: "Comments",
            section: "comments",
            icon: <FaRegCommentDots style={{width:'2rem', height: '2rem'}}/>
        },
        {
            title: "ADTR Reportable",
            section: "retiredIssues",
            icon: <GoIssueClosed  style={{width:'2rem', height: '2rem'}}/>
        },
        {
            title: "Review",
            section: "review",
            icon: <VscPreview style={{width:'2rem', height: '2rem'}}/>
        },
    ]
    const updateStep = (step, section) => {
        setSelectedWidget(section);
        openSection(section);

    }
    return (
        <div style={{textAlign: 'center'}}>
            <StepNavigation labelArray={progressBarData} updateStep={updateStep} pathName={pathname} selectedWidget={selectedWidget}/>
        </div>
    )
}

export default AdtrProgressBar
